var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMes2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_1857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4998 9.99963C17.4996 5.85765 14.1418 2.49963 9.99976 2.49963C5.85788 2.49981 2.49993 5.85776 2.49976 9.99963C2.49976 14.1417 5.85777 17.4995 9.99976 17.4996C14.1419 17.4996 17.4998 14.1418 17.4998 9.99963ZM19.1667 9.99963C19.1667 15.0622 15.0624 19.1666 9.99976 19.1666C4.93729 19.1665 0.83374 15.0621 0.83374 9.99963C0.833916 4.93728 4.9374 0.833794 9.99976 0.833618C15.0623 0.833618 19.1666 4.93717 19.1667 9.99963Z",
    fill: "#2667B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.167 10C14.167 7.69881 12.3012 5.83301 10 5.83301C7.69881 5.83301 5.83301 7.69881 5.83301 10C5.83301 12.3012 7.69881 14.167 10 14.167C12.3012 14.167 14.167 12.3012 14.167 10ZM15.833 10C15.833 13.2217 13.2217 15.833 10 15.833C6.77834 15.833 4.16699 13.2217 4.16699 10C4.16699 6.77834 6.77834 4.16699 10 4.16699C13.2217 4.16699 15.833 6.77834 15.833 10Z",
    fill: "#2667B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 10.0004C10.8333 9.54024 10.4603 9.16656 10.0002 9.16638C9.54001 9.16638 9.16626 9.54013 9.16626 10.0004C9.16644 10.4605 9.54012 10.8334 10.0002 10.8334C10.4602 10.8332 10.8331 10.4603 10.8333 10.0004ZM12.5002 10.0004C12.5001 11.3808 11.3807 12.5002 10.0002 12.5004C8.61964 12.5004 7.50042 11.3809 7.50024 10.0004C7.50024 8.61965 8.61953 7.50037 10.0002 7.50037C11.3808 7.50054 12.5002 8.61976 12.5002 10.0004Z",
    fill: "#2667B0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_1857"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMes2);
export default __webpack_public_path__ + "static/media/mes2.074354f271425faab62a5fa16119b11b.svg";
export { ForwardRef as ReactComponent };